import { Shadow, VStack } from '@genial/components';
import { ReportingEnumsTermsLegalEntityScenarioEnum } from '@genial/services/dist/models';
import { useBreakpointValue } from '@genial/utils';
import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';

import { useDocumentsCenterAction } from '../../../../store/DocumentsCenter/actions';
import { exportingFileNameDocumentsCenter } from '../../../../store/DocumentsCenter/atom';
import { DocumentsCenterLinkList } from '../../constants';
import { DocumentsCenterAccordion } from '../DocumentsCenterAccordion';

interface DocumentsCenterListProps {
  data: DocumentsCenterLinkList;
}
export const DocumentsCenterAccordionList: React.FC<DocumentsCenterListProps> = ({ data }) => {
  const [currentAccordionActive, setCurrentAccordionActive] = useState<number | null>(null);
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const isExporting = useRecoilValue(exportingFileNameDocumentsCenter);
  const { downloadMultipleDocumentsCenter } = useDocumentsCenterAction();

  const handleExpandAccordion = (index: number) => {
    setCurrentAccordionActive((prev) => (prev === index ? null : index));
  };

  const handleDownloadMultipleFile = async (
    fileName: ReportingEnumsTermsLegalEntityScenarioEnum
  ) => {
    await downloadMultipleDocumentsCenter(fileName);
  };

  return (
    <Shadow level={1} borderRadius="sm" padding="inline.xxs">
      <VStack space="stack.xxxs">
        {data.map((item, index) => (
          <DocumentsCenterAccordion
            key={item.title}
            isMobile={isMobile}
            isLoading={isExporting === item.fileName}
            accordionState={currentAccordionActive === index ? 'opened' : 'closed'}
            onExpand={() => handleExpandAccordion(index)}
            onDownload={handleDownloadMultipleFile}
            {...item}
          />
        ))}
      </VStack>
    </Shadow>
  );
};
